import React from 'react'
import { Box, Checkbox, Typography } from '@mui/material'
import StyledCard from '../StyledCard'

const SectionCard = ({ 
    section, 
    isSelected, 
    onChange,
    lastSection,
    hasChildren = false
}) => {
    return (
        <StyledCard
            sx={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                },
                mb: lastSection ? 6 : 2
            }}
            onClick={() => onChange(section)}
        >
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                p: 0 
            }}>
                <Checkbox
                    checked={isSelected}
                    onChange={() => onChange(section)}
                    onClick={() => onChange(section)}
                    sx={{
                        padding: '4px',
                        backgroundColor: '#FFFFFF',
                        '& .MuiSvgIcon-root': {
                            fontSize: 18,
                        },
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-checked': {
                            backgroundColor: '#FFFFFF',
                        },
                        '&.MuiCheckbox-root': {
                            color: '#D1D5DB',
                            backgroundColor: '#FFFFFF',
                            '&.Mui-checked': {
                                color: '#1F477D',
                            },
                        }
                    }}
                />
                <Typography 
                    sx={{ 
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#374151',
                        flex: 1,
                        // cursor: 'pointer'
                    }}
                >
                    {section.title || section.name || section.section_name}
                </Typography>
                {hasChildren && (
                    <Typography 
                        sx={{ 
                            fontSize: '12px',
                            color: '#6B7280',
                            fontStyle: 'italic'
                        }}
                    >
                        {/* This will be replaced with accordion expand icon */}
                    </Typography>
                )}
            </Box>
        </StyledCard>
    )
}

export default SectionCard 